import styled from "styled-components";


export const NavBarContainer = styled.nav<{ $collapsed: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  background-color: #ffffff;
  border-right: 1px solid #d8dcde;

  width: ${({ $collapsed }) => ($collapsed ? "72px" : "250px")};
  transition: width 0.25s ease;
  height: 100vh; 
  overflow: hidden;
`;

export const MenuList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: 20px;
  font-size: 14px;
  color: #414141;

  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const MenuItem = styled.li<{ $collapsed: boolean }>`
  display: flex;
  align-items: center;
  gap: ${({ $collapsed }) => ($collapsed ? "0" : "12px")};
  justify-content: ${({ $collapsed }) => ($collapsed ? "center" : "flex-start")};

  width: 100%;            
  box-sizing: border-box; 

  padding: 13px 16px;
  cursor: pointer;

  transition: background 0.2s ease, gap 0.2s ease;

  &:hover {
    background-color: #a6a9ff; 
    color: #1D2433; 
  }

  a{
    text-decoration: none;
    color: #414141;
  }

  svg {
        flex-shrink: 0;

        visibility: visible;
        opacity: 1;
    }

    span {
        white-space: nowrap;
        font-size: 14px;
        color: #1F2937;

        display: ${({ $collapsed }) => ($collapsed ? "none" : "inline")};
    }
`;

export const ContainerLogo = styled.div<{ $collapsed: boolean }>`
    display: flex;
    justify-content: center;
    align-items: center;

    padding: 13px 16px;
    padding-bottom: 0px;

    img {
        width: ${({ $collapsed }) => ($collapsed ? "32px" : "")};
        transition: width 0.25s ease;
    }
`
export const EndNavbarContainer = styled.div<{ $collapsed: boolean }>`
    display: flex;
    gap: ${({ $collapsed }) => ($collapsed ? "0" : "16px")};
    justify-content: ${({ $collapsed }) => ($collapsed ? "center" : "flex-start")};
    border-top: 1px solid #F6F6F6;
    padding: 13px 16px;
    color: #4256C8;
    font-size: 14px;
    cursor: pointer;

    transition: gap 0.2s ease;

    p {
        display: ${({ $collapsed }) => ($collapsed ? "none" : "inline")};
        font-size: 14px;
    }

`